<template>
    <div>
        <az-empty-state 
            v-if="!dados || !dados.length" 
            v-show="!hide_empty"
            icon="far fa-calendar-check"
            msg="Nenhum escala disponível para check-in." />

        <template v-else>
            <div v-for="(escala, iex) in dados" :key="iex">
                <div class="card">
                    <div class="card-body d-flex justify-content-between">
                        <escala-agenda-show :agenda="escala.agenda" />
                        <div>
                            {{ escala.usuario.pessoa.st_nome }}
                            <div class="text-right" v-if="escala.agenda.js_classes && escala.agenda.js_classes.length">
                                <a href="#" @click.prevent="filtrar(classe)" v-for="(classe, icx) in escala.agenda.js_classes" :key="icx">
                                    <span class="badge badge-success ml-1">
                                        {{ classe }}
                                    </span>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer d-flex justify-content-between">
                        <div>
                            <span>
                                <i class="fa fa-calendar-o mr-1" aria-hidden="true"></i>
                                {{ $util.getFormatDate(escala.dt_escala) }}
                            </span>
                            <span class="ml-4" v-if="escala.hr_inicio">
                                <i class="fas fa-sign-in-alt fa-fw mr-1"></i>
                                {{ escala.hr_inicio.substr(0,5) }}
                            </span>
                            <span class="ml-4" v-if="escala.hr_termino">
                                <i class="fas fa-sign-out-alt fa-fw mr-1"></i>
                                {{ escala.hr_termino.substr(0,5) }}
                            </span>
                        </div>
                        <div>
                            <button type="button" class="btn btn-success" v-if="!escala.hr_inicio" @click="check_in(escala)">
                                <i class="fa fa-check-circle mr-2" aria-hidden="true"></i>
                                Registrar Check-In
                            </button>

                            <template v-else-if="!escala.hr_termino">
                                <button type="button" class="btn btn-primary mr-1" @click="check_out(escala)">
                                    <i class="fa fa-check-circle mr-2" aria-hidden="true"></i>
                                    Registrar Check-Out
                                </button>
                                <button type="button" class="btn btn-outline-danger" @click="remover_check_in(escala)">
                                    <i class="fa fa-times-circle mr-2" aria-hidden="true"></i>
                                    Cancelar Check-In
                                </button>
                            </template>
                        
                            <template v-else-if="escala.hr_termino">
                                <button type="button" class="btn btn-outline-danger btn-sm" @click="remover_check_out(escala)">
                                    <i class="fa fa-times-circle mr-2" aria-hidden="true"></i>
                                    Cancelar Check-Out
                                </button>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
            
            <pre v-if="false">{{ dados }}</pre>
        </template>
    </div>
</template>

<script>
//import $ from 'jquery';
import AzEmptyState from '../../util/AzEmptyState.vue';
import EscalaAgendaShow from './EscalaAgendaShow.vue';

export default {
    data() { 
        return { 
            dados: null, 
            breadcrumb: null, 
        }
    },

    props: ['hide_empty', 'medico'],

    components: { 
        AzEmptyState,
        EscalaAgendaShow, 
    },

    methods: { 
        filtrar (classe) { 
            this.$emit('filtrar', classe);
        },

        load() { 
            this.$util.load(this, { 
                service: 'plantao_escalas',
                func: 'index',
                parms: { 
                    checkin: true, 
                    id_medico: ( this.medico && this.$store.state.user.id_usuario == 1 ) ? this.medico : null, 
                },
                loadTo: res => { 
                    this.dados = res;
                }
            });
        },

        check_in (escala) { 
            if ( !confirm('Confirma registrar o check-in dessa escala?') ) 
                return;

            this.$util.atualizar(this, { 
                service: 'plantao_escalas',
                func: 'check_in',
                dados: { 
                    id_plantao_escala: escala.id_plantao_escala, 
                    id_medico: ( this.medico && this.$store.state.user.id_usuario == 1 ) ? this.medico : null, 
                },
                toast: true,
                reload: true, 
                callback: () => { 
                    this.$emit('refresh');
                }
            });
        },

        check_out (escala) { 
            if ( !confirm('Confirma registrar o check-out dessa escala?') ) 
                return;

            this.$util.atualizar(this, { 
                service: 'plantao_escalas',
                func: 'check_out',
                dados: { 
                    id_plantao_escala: escala.id_plantao_escala, 
                    id_medico: ( this.medico && this.$store.state.user.id_usuario == 1 ) ? this.medico : null, 
                },
                toast: true,
                reload: true, 
                callback: () => { 
                    this.$emit('refresh');
                } 
            });
        },

        remover_check_in (escala) { 
            if ( !confirm('Confirma remover o check-in dessa escala?') ) 
                return;

            this.$util.atualizar(this, { 
                service: 'plantao_escalas',
                func: 'remover_check_in',
                dados: { 
                    id_plantao_escala: escala.id_plantao_escala, 
                    id_medico: ( this.medico && this.$store.state.user.id_usuario == 1 ) ? this.medico : null, 
                },
                toast: true,
                reload: true, 
                callback: () => { 
                    this.$emit('refresh');
                } 
            });
        },

        remover_check_out (escala) { 
            if ( !confirm('Confirma remover o check-out dessa escala?') ) 
                return;

            this.$util.atualizar(this, { 
                service: 'plantao_escalas',
                func: 'remover_check_out',
                dados: { 
                    id_plantao_escala: escala.id_plantao_escala, 
                    id_medico: ( this.medico && this.$store.state.user.id_usuario == 1 ) ? this.medico : null, 
                },
                toast: true,
                reload: true, 
                callback: () => { 
                    this.$emit('refresh');
                }
            });
        }
    },

    mounted() { 

        if ( this.$route.path.substr(0,8) == '/escalas' ) { 

            this.breadcrumb = [
                { name: "Escalas", path: "/escalas/escalas"},
                { name: "Check-In" },
            ];

            this.$store.commit('setBreadcrumb', this.breadcrumb);

        }

        this.load();
        
    }
}
</script>